// Convierte la hora de una clase a 'HH:MM' de 24 horas.
//
// El formulario de clases deja escribir la hora a mano, y los datos reales lo demuestran:
// junto a '06:00 PM' conviven '6pm', '6.00pm', '6.30 pm' y '8.40 am'. El panel las partia por
// ':' y por el espacio, asi que '6pm' se quedaba en la hora 6 sin AM/PM y el evento se creaba
// a las 6 de la MANANA, y '8.40 am' perdia los 40 minutos.
//
// Hay una copia identica en functions/hours.js: el panel y las Cloud Functions se despliegan
// por separado y no pueden compartir modulo. tests/hours.test.mjs comprueba que no divergen.
export function to24h (valor) {
  const texto = String(valor == null ? '' : valor).trim().toLowerCase()
  // Un solo patron para todas las variantes: hora, separador opcional (':' o '.'), minutos
  // opcionales, y am/pm pegado o separado.
  const m = texto.match(/^(\d{1,2})\s*[:.]?\s*(\d{2})?\s*(am|pm)?$/)
  if (!m) return null

  let horas = parseInt(m[1], 10)
  const minutos = m[2] || '00'
  const periodo = m[3]

  if (horas > 23 || parseInt(minutos, 10) > 59) return null

  if (periodo === 'pm' && horas !== 12) horas += 12
  if (periodo === 'am' && horas === 12) horas = 0
  if (!periodo && horas > 23) return null

  return `${String(horas).padStart(2, '0')}:${minutos}`
}

